import { Attachment, IAttachment } from '@app/models/Attachment'
import { List, Record } from 'immutable'

export interface IFileUploadAttachment {
  attachment: IAttachment
  error: boolean
  file: any
  id: string
  isConfirmDeleteModalOpen: boolean
  key: string
  progress: number
}

const FileUploadAttachmentRecord = Record({
  attachment: new Attachment(),
  error: false,
  file: undefined,
  id: '',
  isConfirmDeleteModalOpen: false,
  key: '',
  progress: 0,
})

export class FileUploadAttachment extends FileUploadAttachmentRecord
  implements IFileUploadAttachment {
  public static fromJS(initialState?: Partial<IFileUploadAttachment>) {
    if (!initialState) {
      return new FileUploadAttachment()
    }

    const { attachment, file, ...rest } = initialState
    return new FileUploadAttachment({
      attachment: Attachment.fromJS(attachment),
      file: file || undefined,
      ...rest,
    })
  }

  public readonly attachment: Attachment
  public readonly error: boolean
  public readonly file: File
  public readonly id: string
  public readonly isConfirmDeleteModalOpen: boolean
  public readonly key: string
  public readonly progress: number

  constructor(initialState?: Partial<IFileUploadAttachment>) {
    initialState ? super(initialState) : super()
  }
}
